import React from "react";
import useSmallNav from "../../../../hooks/useSmallNav";
import { Container } from "react-bootstrap";
import UnderlinedHeader from "../../../molecules/UnderlinedHeader/UnderlinedHeader";
import InfoHero from "../../../molecules/info/InfoHero/InfoHero";
import transporter from "../../../../assets/info/transporter-hero.jpg";
import InfoGrid from "../../../atoms/info/InfoGrid/InfoGrid";
import InfoHeader from "../../../atoms/info/InfoHeader/InfoHeader";
import InfoCard from "../../../molecules/info/InfoCard/InfoCard";
import part1 from "../../../../assets/info/vw-transporter/transporter-t5-fig-1.jpg";
import InfoFooter from "../../../organisms/InfoFooter/InfoFooter";
import styled from "styled-components";
import { popularVehicle } from "../../../../vars/popularVehicles";

const VWTransporter = () => {
  useSmallNav("Volkswagen Transporter");

  return (
    <section className={"popular"}>
      <Container>
        <UnderlinedHeader text={"Volkswagen Transporter"} bolder />
        <InfoHero image={transporter} />
        <InfoGrid>
          <div>
            <InfoHeader
              text={
                "Czy Twój transporter T5 lub T6 jest mocno obciążony? Został przerobiony na kampera?"
              }
            />
            <InfoHeader text={"W takim razie mamy to, czego potrzebujesz!"} />
            <p>
              Pedders z dumą prezentuje zestaw sprężyn i amortyzatorów pasujący
              do tylnej części VW Transporter T5 i T6. Zestaw został specjalnie
              zaprojektowany dla właścicieli pracujących samochodów dostawczych
              lub kamperów, w przypadku których oryginalna konfiguracja okazała
              się nieodpowiednia do bieżących zadań, takich jak przewożenie
              ładunku lub przebudowa kampera, gdzie dodano dodatkowy ciężar.
              Zestaw ma na celu pomóc w ograniczeniu przechylania się i pływania
              nadwozia.
            </p>
            <p>
              Układ amortyzatorów gazowych Pedders charakteryzuje się unikalnym
              charakterem procesu przepływu oleju, który zapewnia progresywną
              reakcję na stale zmieniające się warunki drogowe. W
              przeciwieństwie do istniejących amortyzatorów „wrażliwych na
              położenie”, które przełączają się między mocniejszym i bardziej
              miękkim sterowaniem, amortyzatory Pedders zapewniają progresywny
              współczynnik reakcji na wstrząsy.
            </p>
            <p>
              Wzmocnione sprężyny Pedders są produkowane zgodnie z naszymi
              wymagającymi kryteriami, aby zapewnić ciągłą wydajność. Pełne
              szczegóły tego procesu można znaleźć w filmie po lewej stronie.
            </p>
            <InfoHeader
              size="smaller"
              text={
                "Dostępne dla wszystkich modeli VW T5 i T6 Transporter, w tym 4motion"
              }
            />
            <p>Można kupić następujące części:</p>
            <div>
              <StyledLink href="https://pedders.eu/details/7891">
                2 sprężyny Pedders o dużej wytrzymałości (7891)
              </StyledLink>
            </div>
            <div>
              <StyledLink href="https://pedders.eu/details/120216">
                2 Ulepszone tylne amortyzatory Pedders (120216)
              </StyledLink>
            </div>
          </div>
          <div>
            {popularVehicle
              .find((e) => e.make === "Volkswagen")
              .models.find((e) => e.display === "Transporter")
              .popular.map((item) => (
                <InfoCard
                  key={item.text}
                  name={item.text}
                  to={item.link}
                  photo={item.photo}
                />
              ))}
            <iframe
              width="100%"
              height="300"
              src="https://www.youtube.com/embed/g1aSCo4S2_E"
              title={"VW Transporter Video 1"}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
            <Gray>
              <InfoHeader
                size="smaller"
                text={"Zestaw tylnego zawieszenia do VW T5 Transporter"}
              />
              <div>
                <StyledImgParts
                  src={part1}
                  alt="Zestaw tylnego zawieszenia do VW T5 Transporter"
                />
              </div>
              <ul>
                <li>2 wytrzymałe sprężyny</li>
                <li>2 ulepszone tylne amortyzatory</li>
              </ul>
            </Gray>
            <iframe
              width="100%"
              height="300"
              src="https://www.youtube.com/embed/KnT6sI4QaYk"
              title={"VW Transporter Video 2"}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          </div>
        </InfoGrid>
        {/* <InfoFooter make="Volkswagen" model="Transporter" /> */}
      </Container>
    </section>
  );
};

export default VWTransporter;

const StyledLink = styled.a`
  color: #444444;
  &:hover {
    color: #dc3332;
  }
`;

const StyledImgParts = styled.img`
  width: 100%;
  margin-bottom: 10px;
`;

const Gray = styled.div`
  padding: 25px;
  border-radius: 5px;
  background-color: #f4f4f4;
  margin: 30px 0;
`;
